import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-30adc512")

_pushScopeId("data-v-30adc512")
const _hoisted_1 = {
  class: "font-montserrat",
  "data-testid": "pickup-saved-address-list-modal"
}
const _hoisted_2 = { class: "fixed inset-0 z-40 flex items-center justify-center overflow-hidden py-6 outline-none focus:outline-none" }
const _hoisted_3 = { class: "pickup-saved-address-modal relative flex max-h-screen flex-col overflow-hidden rounded-lg bg-white" }
const _hoisted_4 = { class: "border-b border-gray-lp-400 px-4 py-4" }
const _hoisted_5 = { class: "flex w-full items-center gap-4" }
const _hoisted_6 = { class: "mr-4 w-full text-20px font-semibold text-black-lp-100" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "overflow-y-auto px-3 pt-3" }
const _hoisted_9 = { class: "flex flex-col flex-grow overflow-auto" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "mr-2 rounded bg-gray-lp-1300 px-2 py-0.5 text-12px font-medium text-black-lp-100"
}
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "font-medium" }
const _hoisted_16 = { class: "mt-1 text-gray-lp-800" }
const _hoisted_17 = { class: "text-gray-lp-800" }
const _hoisted_18 = { class: "mt-2 flex items-center gap-2" }
const _hoisted_19 = {
  key: 1,
  class: "h-4 w-px bg-gray-lp-400"
}
const _hoisted_20 = {
  key: 2,
  class: "h-4 w-px bg-gray-lp-400"
}
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "flex gap-2 border-t border-gray-lp-400 p-3" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "fixed inset-0 z-30 bg-black opacity-50" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_ModalAddNewAddress = _resolveComponent("ModalAddNewAddress")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("pickupAddress.savedList.title")), 1),
            _createVNode("div", _hoisted_7, [
              _createVNode("img", {
                src: _imports_0,
                class: "h-4 w-4 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                alt: "x"
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listDataSavedAddress, (addressData, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "mb-3 flex justify-between",
              "data-testid": `pickup-saved-address-card-${addressData.pcaId}`
            }, [
              _createVNode("div", {
                class: ["flex w-full gap-2 rounded-lg border p-3 text-14px text-black-lp-100", {
                'bg-white': addressData.pcaId !== _ctx.selectedAddress.pcaId,
                'border-gray-lp-400': addressData.pcaId !== _ctx.selectedAddress.pcaId,
                'border-blue-lp-700 bg-blue-lp-600':
                  addressData.pcaId === _ctx.selectedAddress.pcaId
              }]
              }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    (addressData.pcaIsDefault)
                      ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("pickupAddress.common.primary")), 1))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_12, _toDisplayString(addressData.pcaName), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("span", _hoisted_14, _toDisplayString(addressData.pcaPicName), 1),
                    _createVNode("span", _hoisted_15, " - " + _toDisplayString(addressData.pcaPhoneNumber), 1)
                  ]),
                  _createVNode("div", _hoisted_16, _toDisplayString(addressData.pcaDistrict.name), 1),
                  _createVNode("div", _hoisted_17, _toDisplayString(addressData.pcaAddress), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "mt-2 flex items-center text-left text-14px text-gray-lp-800",
                    "data-testid": "pickup-saved-address-link-coordinates",
                    onClick: ($event: any) => (_ctx.openCoordinates(addressData.pcaLatlon))
                  }, [
                    _createVNode(_component_Icons, {
                      name: "location-pin",
                      class: "mr-1 h-3 w-3 text-gray-lp-800"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupAddress.common.coordinates")) + " : " + _toDisplayString(addressData.pcaLatlon), 1)
                  ], 8, ["onClick"]),
                  _createVNode("div", _hoisted_18, [
                    (_ctx.listDataSavedAddress.length > 1)
                      ? (_openBlock(), _createBlock(_component_LpButton, {
                          key: 0,
                          title: _ctx.$t('pickupAddress.common.delete'),
                          "data-testid": "pickup-saved-address-button-delete",
                          fontWeight: "medium",
                          textSize: 12,
                          textColor: "red-lp-2400",
                          color: 
                      addressData.pcaId === _ctx.selectedAddress.pcaId
                        ? 'blue-lp-600'
                        : 'white'
                    ,
                          compact: "",
                          onClick: 
                      () => {
                        _ctx.onChooseDelete(addressData);
                      }
                    
                        }, null, 8, ["title", "color", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.listDataSavedAddress.length > 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_19))
                      : _createCommentVNode("", true),
                    _createVNode(_component_LpButton, {
                      title: _ctx.$t('pickupAddress.savedList.edit'),
                      "data-testid": "pickup-saved-address-button-edit",
                      fontWeight: "medium",
                      textSize: 12,
                      textColor: "red-lp-2400",
                      color: 
                      addressData.pcaId === _ctx.selectedAddress.pcaId
                        ? 'blue-lp-600'
                        : 'white'
                    ,
                      compact: "",
                      onClick: 
                      () => {
                        _ctx.showModalAddAddress('edit', addressData);
                      }
                    
                    }, null, 8, ["title", "color", "onClick"]),
                    (addressData.pcaIsDefault === false)
                      ? (_openBlock(), _createBlock("div", _hoisted_20))
                      : _createCommentVNode("", true),
                    (addressData.pcaIsDefault === false)
                      ? (_openBlock(), _createBlock(_component_LpButton, {
                          key: 3,
                          title: _ctx.$t('pickupAddress.savedList.setPrimary'),
                          "data-testid": "pickup-saved-address-button-set-default",
                          fontWeight: "medium",
                          textSize: 12,
                          textColor: "red-lp-2400",
                          color: 
                      addressData.pcaId === _ctx.selectedAddress.pcaId
                        ? 'blue-lp-600'
                        : 'white'
                    ,
                          compact: "",
                          onClick: 
                      () => {
                        _ctx.setPickupCorporateAddressDefault(addressData);
                      }
                    
                        }, null, 8, ["title", "color", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  (addressData.pcaId === _ctx.selectedAddress.pcaId)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "check-circle",
                        class: "h-6 w-6 text-blue-lp-700"
                      }))
                    : (_openBlock(), _createBlock(_component_LpButton, {
                        key: 1,
                        title: _ctx.$t('pickupAddress.common.select'),
                        "data-testid": "pickup-saved-address-button-select",
                        fontWeight: "semibold",
                        textSize: 10,
                        textColor: "white",
                        color: "red-lp-2400",
                        small: "",
                        customClass: "pickup-address-select-button",
                        onClick: 
                    () => {
                      _ctx.onChooseButtonPressed(addressData);
                    }
                  
                      }, null, 8, ["title", "onClick"]))
                ])
              ], 2)
            ], 8, ["data-testid"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_LpButton, {
            title: _ctx.$t('pickupAddress.common.back'),
            fontWeight: "semibold",
            textSize: 10,
            isWidthFull: "true",
            outline: "true",
            textColor: "red-lp-2400",
            color: "red-lp-2400",
            customClass: "border-red-lp-2400 h-8",
            onClick: _ctx.onClose
          }, null, 8, ["title", "onClick"]),
          _createVNode(_component_lp_button, {
            class: "whitespace-nowrap",
            title: _ctx.$t('pickupAddress.savedList.add'),
            "data-testid": "pickup-saved-address-button-add",
            textColor: "red-lp-2400",
            color: "red-lp-2400",
            textSize: 10,
            isWidthFull: "true",
            outline: "true",
            iconV2: "",
            iconLeft: "plus-icon",
            iconV2Fill: "#ED1C24",
            sizeIcon: "w-5",
            disabled: _ctx.listDataSavedAddress.length >= _ctx.listAddressLimit,
            customClass: "h-8",
            onClick: _cache[2] || (_cache[2] = 
              () => {
                _ctx.showModalAddAddress('add');
              }
            )
          }, null, 8, ["title", "disabled"])
        ])
      ], 512), [
        [_vShow, !_ctx.isAddAddress && !_ctx.isDeleteConfirm]
      ]),
      _withDirectives(_createVNode(_component_ModalAddNewAddress, {
        formType: _ctx.formType,
        isVisible: _ctx.isAddAddress,
        onClose: _ctx.closeModalAddress,
        onOnSuccess: _ctx.onAddressFormSuccess,
        clientId: _ctx.editData.pcaClientId || _ctx.clientId,
        idAddress: _ctx.editData.pcaId,
        modelValue: _ctx.editData,
        forceDefault: _ctx.isForceDefault
      }, null, 8, ["formType", "isVisible", "onClose", "onOnSuccess", "clientId", "idAddress", "modelValue", "forceDefault"]), [
        [_vShow, _ctx.isAddAddress]
      ])
    ]),
    (_ctx.isDeleteConfirm)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.onSubmitDelete,
          onClose: 
        () => {
          _ctx.isDeleteConfirm = false;
        }
      ,
          title: _ctx.$t('pickupAddress.deleteConfirmation.title'),
          message: _ctx.$t('pickupAddress.deleteConfirmation.message'),
          image: "badge-confirmation-general",
          textSuccess: _ctx.$t('pickupAddress.common.delete'),
          textCancel: _ctx.$t('pickupAddress.common.cancel'),
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true),
    _hoisted_23
  ]))
})